import firebase from "firebase";
import dayjs from "dayjs";
import {isCache} from "../plugins/firebase";

export const getCurrentUser = async (project_id, uid, planId, isCacheLocal) => {
  let currentUser = null;

  const path = 'USER_' + JSON.stringify({
    project_id, uid, planId
  })

  const cache = localStorage.getItem(path);
  if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {

    const data = await firebase.firestore()
      .collection('projects')
      .doc(project_id)
      .collection('users')
      .where('uid', '==', uid)
      .get()


    data.forEach((subDoc) => {
      currentUser = subDoc.data();
    });

    if(isCache || isCacheLocal) {

      localStorage.setItem(path, JSON.stringify({currentUser, expire: dayjs().add(10, 'minute').unix()}))
    }

  } else {
    currentUser = JSON.parse(cache).currentUser
  }

  if (planId) {
    // console.log(currentUser.plan_permission, currentUser, 'currentUser')
    if (currentUser.plan_permission && currentUser.plan_permission[planId]) {
      return currentUser.plan_permission[planId] || {}
    }
    return currentUser[planId] || {}
  }


  return currentUser;
}

export const getPermission = async (project_id, uid, planId, returnAllPermission, isCacheLocal) => {

  const path = 'PERM_' + JSON.stringify({
    project_id, uid, planId
  })

  const cache = localStorage.getItem(path);

  console.log(cache, 'cache')

  let user = {};

  if (!cache || Number(JSON.parse(cache).expire) < dayjs().unix()) {
    let currentUser = await getCurrentUser(project_id, uid);

    if (currentUser.role === 'admin') {
      if (returnAllPermission) {
        return null
      }
      return {
        available_jobs: null,
        available_objects: null
      }
    }

    const user_d = await firebase.firestore()
      .collection('projects')
      .doc(project_id)
      .collection('users')
      .where('isCompany', '==', true)
      .where('company', '==', currentUser.company)

      .get();

    user_d.forEach((subDoc) => {
      user = subDoc.data();
    });
    if(isCache || isCacheLocal) {
      localStorage.setItem(path, JSON.stringify({user, expire: dayjs().add(10, 'minute').unix()}))
    }
  } else {
    user = JSON.parse(cache).user
  }


  if (returnAllPermission) {
    return user
  }

  if (!user.usePermission && !planId) {
    return {
      usePermission: false,
      available_jobs: null,
      available_objects: null,
    }
  }


  if (planId) {

    if (!user.plan_permission || !user.plan_permission[planId] || !user.plan_permission[planId].usePermission) {
      return {
        usePermission: false,
        available_jobs: null,
        available_objects: null,
      }
    }

    return {
      usePermission: true,
      available_jobs: user.plan_permission && user.plan_permission[planId] && user.plan_permission[planId].available_jobs || [],
      available_objects: user.plan_permission && user.plan_permission[planId] && user.plan_permission[planId].available_objects || []
    }
  }

  return {
    usePermission: true,
    available_jobs: user.available_jobs || [],
    available_objects: user.available_objects || []
  }
}


export const getPermissionByUser = async (project_id, uid, plan, currentUserP) => {

  let currentUser = currentUserP || (await getCurrentUser(project_id, uid, plan));

  if (!currentUser.usePermission) {
    return {
      available_objects: null,
    }
  }

  return {
    available_objects: currentUser.available_objects || []
  }
}

export const getPermissionDocs = async (project_id, uid) => {
  let currentUser = await getCurrentUser(project_id, uid);

  if (currentUser.role === 'admin') {
    return {
      available_files: null,
      available_docs: null
    }
  }

  let user = {};
  const user_d = await firebase.firestore()
    .collection('projects')
    .doc(project_id)
    .collection('users')
    .where('isCompany', '==', true)
    .where('company', '==', currentUser.company)
    .get();

  user_d.forEach((subDoc) => {
    user = subDoc.data();
  });

  if (!user.usePermissionDocs) {
    return {
      available_files: null,
      available_docs: null,
    }
  }

  return {
    available_files: user.available_files || [],
    available_docs: user.available_docs || []
  }
}

const _roleCache = new Map(); // key -> { ts, promise }
const DEFAULT_TTL = 10_000; // 10 сек

export function getRoleCached(projectId, { ttlMs = DEFAULT_TTL } = {}) {
  const key = `projectRole:${projectId}:${firebase.auth().currentUser?.uid || "anon"}`;
  const now = Date.now();
  const hit = _roleCache.get(key);

  if (hit && now - hit.ts < ttlMs) {
    return hit.promise;
  }

  const p = firebase.firestore()
    .collection("projects")
    .doc(projectId)
    .get()
    .then((sub) => {
      const data = sub.data();
      let role = "admin";
      if (data) {
        const rules = data.rules;
        if (rules) {
          role = rules[firebase.auth().currentUser.uid];
          if (data.isDemo) {
            role = "admin";
          }
        }
      }
      return role;
    })
    .catch(err => {
      _roleCache.delete(key);
      throw err;
    });

  _roleCache.set(key, { ts: now, promise: p });
  return p;
}

// если нужно руками сбросить
export function invalidateRoleCache(projectId) {
  for (const k of _roleCache.keys()) {
    if (k.startsWith(`projectRole:${projectId}:`)) {
      _roleCache.delete(k);
    }
  }
}

export const getRole = async (project_id, ttlMs = 10_000) => {
  return await getRoleCached(project_id, { ttlMs });
};

export const getMyCompanyUsers = async (project_id) => {
  let currentUser = await getCurrentUser(project_id, firebase.auth().currentUser.uid);


  const user_d = await firebase.firestore()
    .collection('projects')
    .doc(project_id)
    .collection('users')
    // .where('isCompany', '==', true)
    .where('company', '==', currentUser.company)
    .get();
  const result = [];

  user_d.forEach((subDoc) => {
    result.push(subDoc.data().uid);
    result.push(subDoc.id);
  });

  result.push(currentUser.company)

  return result;
}


export const isApprove = async (project_id) => {
  let currentUser = await getCurrentUser(project_id, firebase.auth().currentUser.uid);


  if (currentUser.role === 'admin') {
    return true
  }

  if (currentUser.role === 'worker') {
    return false
  }

  const user_d = await firebase.firestore()
    .collection('projects')
    .doc(project_id)
    .collection('users')
    .where('company', '==', currentUser.company)
    .get();
  let user = null

  user_d.forEach((subDoc) => {
    if (subDoc.data().isCompany) {
      user = subDoc.data();
    }
  });

  return user && user.editorApprove;
}



// WEBPACK FOOTER //
// ./src/firestore/permission.js